import React from 'react';
import ReactDOM from 'react-dom';
import store from './redux/store';
import {Provider} from 'react-redux';
import {Amplify} from 'aws-amplify';
import * as serviceWorker from './serviceWorker';
import {LicenseInfo} from '@mui/x-data-grid-pro';
import {ThemeProvider, StyledEngineProvider} from '@mui/material/styles';
import {createTheme} from '@mui/material/styles';
import {LocalizationProvider} from '@mui/x-date-pickers'; // DatePicker component
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import {AUTH_CONFIG, ENDPOINT, BASE_URL} from './constants';

import Router from './components/Router';
import './index.css';
import './ufli-system.css';

LicenseInfo.setLicenseKey(
  '82c34ed2cdf435f1af8939d37efa8894T1JERVI6Mzg4NzgsRVhQSVJZPTE2Nzc4MTMwMTQwMDAsS0VZVkVSU0lPTj0x',
);

// AWS Amplify
Amplify.configure({
  Auth: AUTH_CONFIG,
  API: {
    endpoints: [
      {
        name: ENDPOINT,
        endpoint: BASE_URL,
      },
    ],
  },
});

const theme = createTheme({
  typography: {
    fontFamily: ['ProximaNova', 'Roboto', 'sans-serif'].join(','),
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Router />
          </LocalizationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
